import SourceSearchOverlay from 'SourceComponent/SearchOverlay/SearchOverlay.component';

import Overlay from 'Component/Overlay';
import Image from 'Component/Image';
import Link from 'Component/Link';

import { AMOUNT_OF_PLACEHOLDERS, SEARCH_CHAR_THRESHOLD } from './SearchOverlay.config';

export class SearchOverlay extends SourceSearchOverlay {

    renderSearchItemAdditionalContent() {
        return null;
    }

    renderNoResults() {
        return <p>{ __('No products found') }</p>;
    }

    renderSearchItem(product, i) {
        const { getProductLinkTo } = this.props;
        const {
            name,
            thumbnail: { url } = {},
            attributes: { brand: { attribute_value: brand } = {} } = {}
        } = product;

        const imageSrc = url || undefined;

        return (
            <li
              block="SearchOverlay"
              elem="Item"
              key={ i }
            >
                <Link
                  block="SearchOverlay"
                  elem="Link"
                  to={ getProductLinkTo(product) }
                  onClick={ this.handleItemClick }
                >
                    <figure
                      block="SearchOverlay"
                      elem="Wrapper"
                    >
                        <Image
                          block="SearchOverlay"
                          elem="Image"
                          src={ imageSrc }
                          alt={ __('Product %s thumbnail.', name) }
                          isPlaceholder={ !imageSrc }
                        />
                        <figcaption block="SearchOverlay" elem="Content">
                            { this.renderSearchItemContent(name, brand) }
                        </figcaption>
                    </figure>
                </Link>
            </li>
        );
    }

    renderSearchCriteria() {
        const { searchCriteria } = this.props;

        return (
            <p
              block="SearchOverlay"
              elem="Criteria"
              mods={ { isVisible: searchCriteria.length > SEARCH_CHAR_THRESHOLD } }
            >
                { __('Results for:') }
                <strong>{ searchCriteria }</strong>
            </p>
        );
    }

    renderCategoriesResults() {
        const { isLoading, categoriesResults: { total_count = 0, items }, getCategoryLinkTo } = this.props;

        if (isLoading) {
            return null;
        }

        if (!isLoading && total_count === 0) {
            return null;
        }

        return (
            <div block="SearchOverlay" elem="Group">
                <span>{ __('Categories') }</span>
                <ul>
                    { items.map((category, index) => (
                        <li key={ index }>
                            <Link
                              to={ getCategoryLinkTo(category) }
                              onClick={ this.handleItemClick }
                            >
                                { category.name }
                            </Link>
                        </li>
                    )) }
                </ul>
            </div>
        );
    }

    renderPagesResults() {
        const { isLoading, pagesResults: { total_count = 0, items }, getPageLinkTo } = this.props;

        if (isLoading) {
            return null;
        }

        if (!isLoading && total_count === 0) {
            return null;
        }

        return (
            <div block="SearchOverlay" elem="Group">
                <span>{ __('Pages') }</span>
                <ul>
                    { items.map((page, index) => (
                        <li key={ index }>
                            <Link
                              to={ getPageLinkTo(page) }
                              onClick={ this.handleItemClick }
                            >
                                { page.title }
                            </Link>
                        </li>
                    )) }
                </ul>
            </div>
        );
    }

    renderSearchResultsAdditional() {
        const {
            categoriesResults: { total_count: categoriesCount = 0 },
            pagesResults: { total_count: pagesCount = 0 }
        } = this.props;

        if (categoriesCount === 0 && pagesCount === 0) {
            return null;
        }

        return (
            <div block="SearchOverlay" elem="Additional">
                { this.renderCategoriesResults() }
                { this.renderPagesResults() }
            </div>
        );
    }

    renderSearchResults() {
        const { searchCriteria, searchResults, isLoading } = this.props;

        if (searchCriteria.length < SEARCH_CHAR_THRESHOLD + 1) {
            return this.renderNoSearchCriteria();
        }
        if (!searchResults.length && !isLoading && !this.timeout) {
            return this.renderNoResults();
        }
        const resultsToRender = (isLoading || this.timeout) ? Array(AMOUNT_OF_PLACEHOLDERS).fill({}) : searchResults;

        return (
            <ul>
                { resultsToRender.map((item, i) => this.renderSearchItem(item, i)) }
            </ul>
        );
    }

    render() {
        const { hideOverlay } = this.props;

        if (hideOverlay) {
            return (
                <article
                  block="SearchOverlay"
                  elem="Results"
                  aria-label="Search results"
                >
                    { this.renderSearchResults() }
                </article>
            );
        }

        return (
            <Overlay
              id="search"
              mix={ { block: 'SearchOverlay' } }
            >
                { this.renderSearchCriteria() }
                <article
                  block="SearchOverlay"
                  elem="Results"
                  aria-label="Search results"
                >
                    { this.renderSearchResults() }
                    { this.renderSearchResultsAdditional() }
                </article>
            </Overlay>
        );
    }
}

export default SearchOverlay;
